import type { AggregateDef } from '../core/schema/types';

export function formatAggregateValue(value: unknown, aggregate: AggregateDef): string {
  if (value == null) return '';

  const numValue = typeof value === 'number' ? value : Number(value);
  if (isNaN(numValue)) return String(value);

  if (aggregate.format) {
    const decimals = aggregate.format.decimals ?? 2;
    let formatted = numValue.toFixed(decimals);

    if (aggregate.format.commas) {
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      formatted = parts.join('.');
    }

    return formatted;
  }

  switch (aggregate.fn) {
    case 'count':
      return String(Math.round(numValue));
    case 'average':
      return numValue.toFixed(2);
    default:
      return numValue.toLocaleString();
  }
}
